'use client';

import { useQuery } from '@tanstack/react-query';
import { gatedAction } from '@/lib/api/auth-gate';
import { accountKeys } from '@/lib/query-keys';
import { getPricingAction } from './actions';
import type { PricingResponseDto } from './types';

/**
 * Hook reading the live pricing structure from GET /account/billing/pricing.
 *
 * The endpoint is the single source of truth for tier prices, the
 * estate-matter fee, and the bespoke Enterprise marker — no dollar amount
 * lives in the FE source. Surface a loading / error state so the billing
 * tab degrades gracefully when the endpoint is unreachable.
 */
export function usePricing() {
  return useQuery<PricingResponseDto>({
    queryKey: accountKeys.billingPricing,
    queryFn: () => gatedAction(() => getPricingAction()),
    // 5 min stale time mirrors the response's Cache-Control: max-age=300.
    staleTime: 5 * 60 * 1000
  });
}
